<template>
    <div class="multiparams">
        <div>
            <div class="thead flex center vcenter">
                <template v-for="(meta, index) in this.meta.metas" :key="index">
                    <div class="flex wrap center vcenter shrink" :style="meta.style
                        ? { 'width': JSON.parse(meta.style)['width'] }
                        : ''">
                        <p>{{ meta.name }}</p>
                    </div>
                </template>
                <div v-if="!meta?.entity?.disabled && !meta?.disabled?.[meta.entity?.key]">
                </div>
            </div>
            <div class="tbody flex wrap center vcenter">
                <template v-for="(key, index) in Object.keys(models)" :key="index">
                    <KeepAlive>
                        <row v-if="!models[key].delete" class="flex center vcenter shrink">
                            <template v-for="(meta, j) in this.meta.metas" :key="j">
                                <div class="flex wrap center vcenter shrink" :style="meta.style
                                    ? { 'width': JSON.parse(meta.style)['width'] }
                                    : ''">
                                    <Switch v-if="meta.type === 'switch'" :meta="meta" :vm="models[key][meta.key]"
                                        :disabled="this.meta?.disabled?.[meta.key]"
                                        @onchange="(obj) => this.models[`R${index}`][obj.key] = obj.value">
                                    </Switch>
                                    <MetaBox v-else :meta="meta" :vm="models[key][meta.key]"
                                        :data="this.meta.extras?.[meta.key]?.contents || 'L'"
                                        :validate="validate ? validate[`R${index}`] ? validate[`R${index}`][meta.key] : false : false"
                                        :disabled="this.meta?.disabled?.[meta.key]" @onchange="(obj) => {
                                            this.models[`R${index}`][obj.key] = obj.value
                                            if (this.hints[`R${index}`])
                                                this.hints[`R${index}`][obj.key] = obj.hint
                                            if (this.errors[`R${index}`])
                                                this.errors[`R${index}`][obj.key] = obj.error
                                        }">
                                    </MetaBox>
                                </div>
                            </template>
                            <div v-if="!meta?.entity?.disabled && !meta?.disabled?.[meta.entity?.key]"
                                class="flex wrap center vcenter">
                                <img v-lazy="'/images/plus.webp'" width="24" height="24" alt="add" loading="lazy"
                                    @click="add">
                                <img v-if="length > 1" v-lazy="'/images/xmark.webp'" width="24" height="24" alt="delete"
                                    loading="lazy" @click="() => models[key] = { delete: true }">
                            </div>
                        </row>
                    </KeepAlive>
                </template>
            </div>
        </div>
        <div class="tfooter flex center vcenter">
            <template v-for="(meta, index) in this.meta.metas" :key="index">
                <div class="flex wrap center vcenter shrink" :style="meta.style
                    ? { 'width': JSON.parse(meta.style)['width'] }
                    : ''">
                </div>
            </template>
            <div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import MetaBox from './MetaBox.vue'
import Switch from './Switch.vue'

export default {
    name: 'MultiParams',
    props: ['meta', 'vm', 'id', 'validate'],
    inject: ['base'],
    components: { MetaBox, Switch },
    computed: {
        extras() {
            return this.meta.extras[this.meta.entity.key]?.contents
        }
    },
    created() {
        if (this.vm && Object.keys(this.vm['R0'] || {}).length !== 0)
            this.models = this.vm
        else {
            this.add()
            this._default()
        }
    },
    data() {
        return {
            models: {},
            hints: {},
            errors: {},
            length: 0
        }
    },
    watch: {
        vm: {
            handler(newVM, oldVM) {
                if (this.vm && Object.keys(this.vm['R0'] || {}).length !== 0)
                    this.models = this.vm
            },
            deep: true
        },
        extras: {
            handler(newExtras, oldExtras) {
                if (JSON.stringify(newExtras) !== JSON.stringify(oldExtras))
                    this._default()
            },
            deep: true
        },
        models: {
            handler(newModels, oldModels) {
                this.length = 0
                Object.keys(this.models).forEach(key => {
                    if (!this.models[key].delete)
                        this.length += 1
                })

                this.$emit('onchange', {
                    key: this.meta.entity.key,
                    value: this.reformat(this.models),
                    hint: this.reformat(this.hints),
                    error: this.reformat(this.errors)
                })
            },
            deep: true
        }
    },
    methods: {
        add() {
            let keys = Object.keys(this.models)
            let index = this.base.Util().validate(keys)
                ? Number(keys[keys.length - 1].replaceAll('R', '')) + 1
                : 0
            this.models[`R${index}`] = {}
            this.hints[`R${index}`] = {}
            this.errors[`R${index}`] = {}

            return index
        },
        _default() {
            let index = 0
            let data = this.meta.extras[this.meta.entity.key]?.contents || ''
            if (data)
                for (const i in data)
                    if (Array.isArray(data[i]?.text))
                        data[i]?.text.forEach((element) => {
                            this.models[`R${index}`][data[i]?.id] = element
                            index = this.add()
                        })
                    else {
                        this.models[`R${index}`][data[i]?.id] = data[i]?.text
                        index = this.add()
                    }
        },
        reformat(source) {
            let keys = Object.keys(source)
            let models = {}
            let index = 0
            for (const key of keys)
                if (!source[key].delete) {
                    let properties = Object.keys(Object.entries(source[key]).reduce((obj, [key, value]) => {
                        if (value !== null && value !== undefined)
                            obj[key] = value
                        return obj
                    }, {})).filter(key => { return this.base.Util().validate(key) })
                    properties = properties.sort()
                    let obj = {}
                    properties.forEach((element) => {
                        obj[element] = source[key][element]
                    })

                    models[`R${index}`] = obj
                    index += 1
                }
            return models
        }
    }
}
</script>

<style scoped src="../../../assets/css/components/inputs/multiparams.css"></style>